module.exports = __webpack_public_path__ + "static/media/bg-contact-form-p.46251e9a.png";